import { useState, useEffect } from 'react';
import { MonthEnum } from '../../../../../enums/monthEnum';
import { useDispatch, useSelector } from 'react-redux';
import { GetMenuByCafeteriaIdServingDate } from '../../../../../reduxToolkit/FoodieMenu/MenuApi';
import TableFunction from '../../../../../components/table/TableFunction';
import { toast } from 'react-toastify';
import { errorMsg } from '../../../../../Apis/functions';
import { useTranslation } from 'react-i18next';
import { permissionObj } from './../../../../../Helpers/permission';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
export const CalendarApp = ({isFutureDate, DEV, permission}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [diner, setDiner] = useState('');
    const [monthName, setMonthName] = useState('');
    const [resultsToShow, setResultsToShow] = useState('');
    const { allCafeterias } = useSelector((state) => state.FoodieShiftSlice);
    const emptyFields = false;

    // Setup pagination using a custom table utility
    const { pagination, page, rowsPerPage } = TableFunction({
        data: resultsToShow,
        labelRowsPerPage: 'menus_per_page',
        fixedPagination: false,
        hasContainer: false,
    });

    // Effect to update month name and fetch menu data when date or diner changes
    useEffect(() => {
        const monthNumber = selectedDate.getMonth() + 1;
        setMonthName(MonthEnum[monthNumber]);
        if (diner) {
            dispatch(
                GetMenuByCafeteriaIdServingDate({
                    cafeteriaId: diner,
                    servingDate: selectedDate.getTime(),
                    pagination: {
                        page: page,
                        size: rowsPerPage,
                    },
                }),
            ).then(({ payload }) => {
                const { data, code, message } = payload;
                if (data) {
                    setResultsToShow(data.data);
                    toast.success(t('search_completed_successfully'));
                } else {
                    errorMsg(code);
                }
            });
        }
    }, [selectedDate, diner]);

     // Handles input changes (either a date object or an event)
    const handleChange = (value) => {
        if (value instanceof Date) {
            setSelectedDate(value);
        } else if (value?.target?.name === 'date') {
            const newDate = new Date(value.target.value);
            if (!isNaN(newDate)) {
                setSelectedDate(newDate);
            }
        } else if (value?.target?.name === 'diner') {
            setDiner(value.target.value);
        }
    };

    // Returns true if the menu can be updated based on date and user permissions.
    const canUpdateMenu = (item) => {
    return (
        isFutureDate(item) &&
        (DEV || permission?.includes(permissionObj?.WEB_FOODIE_MENU_UPDATE))
    );
};

const resultsWithTotalStock = {
    ...resultsToShow,
    content: Array.isArray(resultsToShow?.content)
        ? resultsToShow.content.map((item) => ({
              ...item,
              totalStock: Array.isArray(item.foodieMealTimeStocks)
                  ? item.foodieMealTimeStocks.reduce((sum, mt) => sum + (mt.stock || 0), 0)
                  : 0,
          }))
        : [],
};

    return {
        handleChange,
        emptyFields,
        monthName,
        date: selectedDate,
        diner,
        allCafeterias,
        menuByCafeteriaIdServingDate: resultsWithTotalStock,
        pagination,
        canUpdateMenu,
    };
};
